// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const toDecimal = (inputText: string) => {
    if (!inputText) {
        return "";
    }
    let transformedInput = inputText;

    const startWithMinus = transformedInput.indexOf("-") === 0;
    // remove any minus sign
    transformedInput = transformedInput.replace(/\-/g, "");
    // if there already one in the start of the text, add it back.
    if (startWithMinus) {
        transformedInput = "-".concat(transformedInput);
    }

    const periodIndex = transformedInput.indexOf(".");

    if (periodIndex > -1) {
        const integerPart = transformedInput.substring(0, periodIndex);
        let decimalPart = transformedInput.substring(periodIndex);

        if (decimalPart) {
            decimalPart = decimalPart.replace(/\./g, "");
        }

        transformedInput = `${integerPart}.${decimalPart}`;
    }

    transformedInput = transformedInput.replace(/[^\-0-9\.]/g, "");
    let floatValue = parseFloat(transformedInput);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(floatValue)) {
        floatValue = 0;
    }
    return floatValue.toString();
};
